// Constants
import { ROLES } from '@/constants'
// Layouts
const DefaultLayout = () => import('@/views/layout/DefaultLayout')
// Views (Public)
const Login = () => import('@/views/authentication/Login')
const Register = () => import('@/views/authentication/Register')
const RecoverPassword = () => import('@/views/authentication/RecoverPassword')
// Views (DefaultLayout)
const CompanyBrand = () => import('@/views/company/CompanyBrand')
const CompanyReferrals = () => import('@/views/company/CompanyReferrals')
const Dashboard = () => import('@/views/app/Dashboard')
const UserFom = () => import('@/views/user/UserForm')
const PartnerCompanyByTabs = () => import('@/views/partnerCompany/PartnerCompanyByTabs')
const CompanyBillingData = () => import('@/views/company/CompanyBillingData')
const WalletByTabs = () => import('@/views/company/WalletByTabs')

export default [
  // DefaultLayout
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          roles: [ROLES.partner_partner.value, ROLES.partner_brand.value]
        }
      },
      // User
      {
        path: '/profile',
        name: 'profile',
        component: UserFom,
        meta: {
          roles: [ROLES.partner_partner.value, ROLES.partner_brand.value]
        }
      },
      // Company
      {
        path: '/billing',
        name: 'billing',
        component: CompanyBillingData,
        meta: {
          roles: [ROLES.partner_partner.value, ROLES.partner_brand.value]
        }
      },
      // Wallet
      {
        path: '/wallet',
        name: 'Wallet',
        component: WalletByTabs,
        meta: {
          roles: [ROLES.partner_partner.value, ROLES.partner_brand.value]
        }
      },
      // Partner-Company
      {
        path: '/partner-companies',
        name: 'partner-companies',
        component: PartnerCompanyByTabs,
        meta: {
          roles: [ROLES.partner_partner.value, ROLES.partner_brand.value]
        }
      },
      // Others
      {
        path: '/brand',
        name: 'brand',
        component: CompanyBrand,
        meta: {
          roles: [ROLES.partner_partner.value, ROLES.partner_brand.value]
        }
      },
      {
        path: '/referrals',
        name: 'referrals',
        component: CompanyReferrals,
        meta: {
          roles: [ROLES.partner_partner.value, ROLES.partner_brand.value]
        }
      }
    ]
  },
  // Auth
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/recover-password',
    name: 'recoverPassword',
    component: RecoverPassword,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      isPublic: true
    }
  },
  { path: '*', redirect: '/' }
]
